module.exports = __webpack_public_path__ + "static/media/jest.dc4dd3cf.svg";